import {
  menuBtn,
  menuToggles,
  navbarMenu,
  overlayMobile,
  mq,
  subMenus,
} from './vars';

const closeMenu = () => {
  menuBtn.classList.remove("open");
  menuToggles.forEach(tog => {
    tog.classList.remove('open');
  })
  navbarMenu.classList.remove("open");
  overlayMobile.classList.remove("open");
  subMenus.forEach(sub => {
    sub.classList.remove('active');
  })
}

document.addEventListener("keyup", (e) => {
  if (e.key === "Escape") closeMenu();
});

overlayMobile.addEventListener("click", closeMenu);

// Always fire closeMenu() at 1024px breakpoint
mq.addEventListener("change", (event) => {
  if (event.matches) closeMenu();
});

